// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { MainPanel } from "types";
import { IAction } from "actions";
import { IState } from "states/states";
import { IConnectorData } from "states/ocppstates";
import { ConnectorStatus } from "model/connector";

import ChargerList from "./ChargerList";
import ChargerStatistics from "view/comp/ChargerStatistics";

const MAX_CONNECTORS = 3;

interface IChargerWidgetProps {
  isChargerDetail: boolean;
  totalConnectors: number;
  totalConnectorsCharging: number;
}

const mapStateToProps = (state: IState) => {
  const totalConnectors = state.ocpp.charger.reduce(
    (prev, curCharger, curIndex) =>
      prev +
      (curCharger.numberofconnectors ?? (state.ocpp.connectorData[curIndex]?.length ?? 2) - 1),
    0,
  );

  const totalConnectorsCharging = state.ocpp.charger.reduce((prev, curCharger, curIndex) => {
    const connectorData = state.ocpp.connectorData[curIndex] as IConnectorData[] | undefined;
    const connectorsCharging = connectorData?.reduce(
      (prevd, curConnector) => prevd + (curConnector?.status === ConnectorStatus.CHARGING ? 1 : 0),
      prev,
    );
    return prev + (connectorsCharging ?? 0);
  }, 0);

  const props: IChargerWidgetProps = {
    isChargerDetail: state.router.panel === MainPanel.CHARGERDETAIL,
    totalConnectors,
    totalConnectorsCharging,
  };
  return props;
};

interface IChargerWidgetState {}

interface IChargerWidgetDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IChargerWidgetDispatch = {};
  return dispatchProps;
};

const messages = defineMessages({
  connector: {
    id: "Connector",
  },
  editHint: {
    id: "change settings",
  },
  printHint: {
    id: "print",
  },
});

class ChargerWidgetComponent extends React.Component<
  IChargerWidgetProps & IChargerWidgetDispatch & WrappedComponentProps,
  IChargerWidgetState
> {
  public render() {
    return (
      <>
        <div id="chargerpage">{this.renderWidget()}</div>
      </>
    );
  }

  private renderWidget() {
    return (
      <div
        id="chargerpage-widget"
        className={`d-print-none ${
          this.props.isChargerDetail ? "d-none d-md-block" : "col-12"
        } col-md-12 col-lg-12 col-xl-12`}
      >
        {this.props.totalConnectors > MAX_CONNECTORS && <ChargerStatistics />}
        {(this.props.totalConnectors <= MAX_CONNECTORS ||
          this.props.totalConnectorsCharging > 0) && (
          <ChargerList isDashboard={true} showOnlyCharging={true} />
        )}
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ChargerWidgetComponent));
